<template>
  <div class="bg_white">
    <van-nav-bar title="证书查询" />
    <van-cell-group>
      <van-field required v-model="param.idCardNo" label="证件号码" placeholder="请输入身份证号" />
      <van-field required center v-model="param.name" label="姓名" placeholder="请输入真实姓名">
        <template #button>
          <van-button size="small" type="primary" @click="search">搜索</van-button>
        </template>
      </van-field>
    </van-cell-group>
    <div class="fileImage2" v-if="fileList.length>0"></div>
    <div v-for="item in fileList" :key="item.id">
      <div class="fileImage" >
        <img :src="common.getImageUrl(photo)" alt="" class="filePic">
        <span class="fileNo">{{ item.userFile.fileNo }}</span>
        <span class="name">{{ userName }}</span>
        <span class="type1">{{ getQulType(item.userFile.quaType) }}</span>
        <span class="sex">{{ gendle == 1 ? '男' : '女' }}</span>
        <span class="type2">{{ getWorkType(item.userFile.workType) }}</span>
        <span class="start">{{ item.userFile.createTime }}</span>
        <span class="duration">{{ item.userFile.startTime + "至" + item.userFile.endTime }}</span>
      </div>
      <div>
        <van-cell-group  title="培训档案">
          <van-cell title="姓名" :value="item.trainStudent.studentName" />
          <van-cell title="性别" :value="gendle == 1 ? '男' : '女'"  />
          <van-cell title="证件号码" :value="item.userFile.idCardNo"  />
          <van-cell title="单位类型" :value="getWorkType(item.userFile.workType)"  />
          <van-cell title="资格类型" :value="getQulType(item.trainStudent.applyQualification)"  />
          <van-cell title="申请类型" :value="getApplyType(item.trainStudent.applyType)"  />
          <!-- <van-cell title="在线学长" :value="getTime(item.studyTime)"  /> -->
          <van-cell title="线上培训" :value="getstudyime(item.trainStudent.applyType,item.trainStudent.applyWorkType,item.trainStudent.applyQualification,0)"  />
          <van-cell title="线下培训" :value="getstudyime(item.trainStudent.applyType,item.trainStudent.applyWorkType,item.trainStudent.applyQualification,1)"  />
          <van-cell title="考试得分" :value="item.trainStudent.score"  />
          <van-cell title="发证日期" :value="item.userFile.createTime"  />
          <van-cell title="有效期限" :value="item.userFile.startTime + '至' + item.userFile.endTime"  />
          <van-cell :title="getTips(item.userFile.startTime)"   />
          <!-- <van-cell title="状态" :value="vipfilter(item.userFile.isVip)" /> -->
        </van-cell-group>
      </div>
    </div>

    

    <!-- <van-empty description="暂无数据" v-if="fileList.length < 1" /> -->
  </div>
</template>

<script>
import { searchCustomFiles, getDictData } from '../../api/custom';
export default {
  data() {
    return {
      tips:"",
      param: {
        idCardNo: '',
        name: '',
        // idCardNo: '',
        // name: ''
      },
      fileList: [],
      workTypeList: [],
      applyTypeList:[],
      quaList: [],
      userName: "",
      photo: "",
      gendle: "",
      // times:{
      //   online:0,
      //   offline:0
      // }

    }

  },
  created() {
    //单位类型
    getDictData("sys_work_type").then(res => {
      this.workTypeList = res.data.list
    }),
      //资格类型
      getDictData("sys_qulification_type").then(res => {
        this.quaList = res.data.list
      })

      //申领类型
      getDictData("sys_apply_type").then(res => {
        this.applyTypeList = res.data.list
      })


      // this.search()
  },
  methods: {
    getTips(times){
      let date=new Date(times)
      let years1=date.getFullYear()+1;
      let years2=date.getFullYear()+2;
      let month=date.getMonth()+1;
      return "第一次复审"+years1+" "+month+"月，第二次复审"+years2+" "+month+"月"
    },
    getstudyime(applyType,applyWorkType,applyQualification,type){
      let times={
        online:0,
        offline:0
      }
      //初次申领
      if(applyType ==1){
        if(applyWorkType ==7){
          times.online=16
          times.offline=16
        }else if(applyWorkType ==1 || applyWorkType ==2 || applyWorkType ==3 || applyWorkType ==4 || applyWorkType ==5|| applyWorkType ==6){
          times.online=24
          times.offline=24
          if(applyQualification ==3){
            times.online=48
            times.offline=24
          }
        }else if(applyWorkType ==9){
          times.online=8
          times.offline=8
        }
      }else{
        //复审
        if(applyWorkType ==7){
          times.online=0
          times.offline=12
        }else if(applyWorkType ==1 || applyWorkType ==2 || applyWorkType ==3 || applyWorkType ==4  || applyWorkType ==5 || applyWorkType ==6){
          times.online=0
          times.offline=16
          if(applyQualification ==3){
            times.online=0
            times.offline=20
          }
        }
        // else if(applyWorkType ==5 ){
        //   times.online=0
        //   times.offline=12
        //   if(applyQualification ==3){
        //     times.online=0
        //     times.offline=20
        //   }
        // }
        else if(applyWorkType ==9){
          times.online=0
          times.offline=8
        }

      }
      if(type==0){
        return times.online;
      }else{
        return times.offline;
      }
      
     
    },
    getTime(time) {
      let h = parseInt(time / 60 / 60 )
      h = h < 10 ? '0' + h : h
      let m = parseInt(time / 60 % 60)
      m = m < 10 ? '0' + m : m
      let s = parseInt(time % 60)
      s = s < 10 ? '0' + s : s
      return h + ":" + m + ":" + s
    },
    search() {
      searchCustomFiles(this.param).then(res => {
        console.log(res)
        if (res.success) {
          this.fileList = res.data.customfile
          this.userName = res.data.userName
          this.photo = res.data.photo
          this.gendle = res.data.gendle

          this.getstudyime()
        } else {
          this.$dialog.alert({
            message: res.message,
            theme: 'round-button',
            confirmButtonText: '确定'
          })
        }
      })
    },
    onClickLeft() {
      this.$router.back()
    },
    onClickRight() {
      this.$router.push("/online")
    },
    getQulType(val) {
      let result = ""
      this.quaList.forEach(item => {
        if (item.dictValue == val) {
          result = item.dictLabel
        }
      })
      return result;

    },
    getWorkType(val) {
      let result = ""
      console.log(val)
      this.workTypeList.forEach(item => {
        if (item.dictValue == val) {
          result = item.dictLabel
        }
        if (item.dictValue == 2 || item.dictValue == 3 || item.dictValue == 4){
          result = "危险化学品单位"
        }
      })
      console.log(result)
      return result;

    },
    getApplyType(val) {
      let result = ""
      this.applyTypeList.forEach(item => {
        if (item.dictValue == val) {
          result = item.dictLabel
        }
      })
      return result;

    },
    getSex(val){
      if(val ==1){
        return "男"
      }else{
        return "女"
      }
    },
  }

};
</script>

<style lang="less">
.fileImage2 {
  width:100%;
  margin: 8px auto;
  border-radius: 6px;
  background: url(../../asset/images/filebg1.png) no-repeat;
  background-size: contain;
  height: 255px;
  overflow: hidden;
}
.fileImage {
  width: 100%;
  margin: 8px auto;
  position: relative;
  // padding: 10px;
  // height: 572px;
  // border: 1px solid #ebedf0;
  border-radius: 6px;
  background: url(../../asset/images/filebg2.png) no-repeat;
  background-size: contain;
  height: 255px;
  overflow: hidden;
  span{
    font-size: 0.8em;
  }
  .filePic{
    position: absolute;
    margin-top: 30px;
    margin-left: 26px;
    width: 90px;
    height: 115px;
  
  }
  .fileNo{
    margin-left: 134px;
    position: absolute;
    margin-top: 39px;
   
  }
  .name{
    margin-left: 134px;
    position: absolute;
    margin-top: 72px;
  }
  .type1{
    margin-left: 252px;
    position: absolute;
    margin-top: 72px;
  }
  .sex{
    margin-left: 134px;
    position: absolute;
    margin-top: 122px;
  }
  .type2{
    margin-left: 252px;
    position: absolute;
    margin-top: 122px;
  }
  .start{
    margin-left: 24px;
    position: absolute;
    margin-top: 181px;
    font-size: 10px;
  }
  .duration{margin-left: 140px;
    position: absolute;
    margin-top: 181px;
    font-size: 10px;
 }
  .manage{margin-left: 24px;
    position: absolute;
    margin-top: 211px;
    font-size: 10px;}
  div {
    color: #333;
    font-size: 12px;
  }

  span {
    color: #000;
    // font-size: 14px;
  }

  .fileInfo1 {
    img {
      width: 100px;
      height: 110px;
    }

    align-items: center;
  }

  .fileInfo2 {
    margin-top: 5px;
    flex-wrap: wrap;

    .box1 {
      width: 45%;
      margin-top: 10px;
    }

    .box2 {
      width: 50%;
    }
  }

  span {
    display: block;
  }

  .green {
    color: green;
  }

  .fileInforight {
    margin-left: 8px;
    flex: 1;

    span {
      color: #333;
    }

    div.box1 {
      width: 100%;
      margin-top: 5px;
    }

    div.box2 {
      width: 45%;
    }

    div.box3 {
      width: 55%;
    }

  }
}</style>

